import type {
  ApplyChannelData, CalcPlanListData, EquityPathType, LoanApplyMarketReqType,
} from '@/api/apply-product/types';
import type { RightPackageTypeEnum, RightSummaryType } from '@/api/rights/types';
import type { quickLoanChannelType } from '@/api/quick-withdraw/types';

export enum TabTypeEnum {
  SPEED = 'speed',
  NORMAL = 'normal',
}

export enum DefaultInitStateEnum {
  DEFAULT = '-1',
  HAS_INIT = '1',
  CATCH_ERROR = '2',
}

// 权益上下文接口
export interface RightsContext {
  // 渠道信息
  channel: ApplyChannelData | quickLoanChannelType;
  // 计费计划数据
  planListData: CalcPlanListData;
  // 金额
  amount: string;
  // 期数
  period: string | number;
  capitalCode?: string;
  // 权益概要数据（用于生成详情URL）
  rightSummaryData?: RightSummaryType;
  // 来源标识
  from?: string;
  // 是否显示加速通道
  showSpeed?: boolean;
  // 是否勾选权益协议
  checkStatus?: boolean;
  // 是否显示tips
  tipShow?: boolean;
  // 是否显示权益详情弹窗
  detailShow?: boolean;
  // 是否显示权益协议弹窗
  contractShow?: boolean;
  // 其他扩展字段
  [key: string]: unknown;
}

// 权益数据接口
export interface RightsDataType {
  loanApplyMarketReq: LoanApplyMarketReqType;
  status: {
    // 是否显示加速通道
    showSpeed?: boolean;
    // 是否勾选权益协议
    checkStatus?: boolean;
    //是否显示权益详情
    detailShow: boolean;
    // 是否显示权益协议
    contractShow: boolean;
  };
}
